import React from 'react';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Alert } from '../../../CommonComponents/OPL/Alert/Alert';
import { useWidgetsMutation } from '../../api/useWidgetsMutation';
import { WidgetDTO, WidgetsDTO } from '../../api/useWidgetsQuery';
import { TabSlug } from '../../types';

interface Props {
  tab: TabSlug;
  widgets: WidgetsDTO;
  widgetToExclude: WidgetDTO;
  onClose(): void;
}

export const ExcludeWidgetModal = ({ tab, widgetToExclude, widgets, onClose }: Props) => {
  const widgetsMutation = useWidgetsMutation({ tab });

  const excludeWidget = async () => {
    try {
      const nextWidgets = {
        included: widgets.included.filter(({ id }) => id !== widgetToExclude.id),
        excluded: [...widgets.excluded, widgetToExclude],
      };

      await widgetsMutation.mutateAsync({ tab, widgets: nextWidgets });

      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal isOpen onRequestClose={onClose} aria={{ labelledby: 'exclude-widget-modal--header' }}>
      <ModalHeader id="exclude-widget-modal--header">Delete Card?</ModalHeader>

      {widgetsMutation.error && (
        <Alert message={widgetsMutation.error.message} variant="error" mb="16" mx="24" />
      )}

      <ModalBody>
        Are you sure you want to delete{' '}
        <Text as="span" fontWeight={600}>
          {widgetToExclude.title}
        </Text>
        {'? '}
        This action cannot be undone.
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose} mr="8">
          Cancel
        </Button>

        <Button isLoading={widgetsMutation.isLoading} variant="error" onClick={excludeWidget}>
          Delete Card
        </Button>
      </ModalFooter>
    </Modal>
  );
};
